import { JSX } from 'react';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Menu } from '@mui/material';

type arrMenuProps = {
    title: string
    icon: JSX.Element
    handle: () => void
}

type IconMenuProps = {
    anchorEl: any,
    setAnchorEl: any,
    arrMenu: arrMenuProps[]
}

export default function IconMenu({ anchorEl, setAnchorEl, arrMenu }: IconMenuProps) {
    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuList>
                {arrMenu.map((item, index) => (
                    <MenuItem key={`menuItem${index}`} onClick={item.handle}>
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText>{item.title}</ListItemText>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
}